import { render, staticRenderFns } from "./LabotestImportComplete.vue?vue&type=template&id=ef661002&scoped=true&"
import script from "./LabotestImportComplete.vue?vue&type=script&lang=ts&"
export * from "./LabotestImportComplete.vue?vue&type=script&lang=ts&"
import style0 from "./LabotestImportComplete.vue?vue&type=style&index=0&id=ef661002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef661002",
  null
  
)

export default component.exports